const commonUtils = {
  getTraceTypeListByShortNum (name) {
    var traceTypeList = []
    if (name === 0) {
      traceTypeList.push(1)
    } else if (name === 1) {
      traceTypeList.push(11)
    } else if (name === 2) {
      traceTypeList.push(21)
      traceTypeList.push(22)
      traceTypeList.push(23)
      traceTypeList.push(24)
      traceTypeList.push(25)
    } else if (name === 3) {
      traceTypeList.push(31)
      traceTypeList.push(32)
    } else if (name === 4) {
      traceTypeList.push(41)
      traceTypeList.push(42)
      traceTypeList.push(43)
    } else if (name === 5) {
      traceTypeList.push(51)
      traceTypeList.push(52)
    } else if (name === 6) {
      traceTypeList.push(61)
      traceTypeList.push(62)
      traceTypeList.push(63)
      traceTypeList.push(64)
      traceTypeList.push(65)
      traceTypeList.push(66)
      traceTypeList.push(67)
      traceTypeList.push(68)
    } else if (name === 7) {
      traceTypeList.push(8)
      traceTypeList.push(71)
      traceTypeList.push(99)
    } else {
      traceTypeList.push(1)
    }

    return traceTypeList
  },
  getShortNumByTraceType (traceType) {
    var shortNum
    if (traceType === 8 || traceType === 99) {
      return 7
    }
    if (traceType > 0 && traceType < 10) {
      shortNum = 0
    } else if (traceType > 10 && traceType < 20) {
      shortNum = 1
    } else if (traceType > 20 && traceType < 30) {
      shortNum = 2
    } else if (traceType > 30 && traceType < 40) {
      shortNum = 3
    } else if (traceType > 40 && traceType < 50) {
      shortNum = 4
    } else if (traceType > 50 && traceType < 60) {
      shortNum = 5
    } else if (traceType > 60 && traceType < 70) {
      shortNum = 6
    } else if (traceType > 70) {
      shortNum = 7
    } else {
      shortNum = 0
    }

    return shortNum
  },
  getUrlByTraceType (data, traceType) {
    let obj
    data.forEach(e => {
      if (e.code === traceType) {
        obj = e.url
        return
      }
    })
    return obj
  },
  getTotalUrl (url) {
    if (!url) {
      return ''
    }
    var totalImageUrl = url
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      return url
    } else {
      if (url.substr(0, 1) === '/') {
        totalImageUrl = 'http://medias.kouyujie.cn' + url
      } else {
        totalImageUrl = 'http://medias.kouyujie.cn/' + url
      }
      return totalImageUrl
    }
  }


}

module.exports = commonUtils



// WEBPACK FOOTER //
// ./src/tools/commonUtils.js